import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import CountryCode from "../register/signup/phone/CountryCode";
import { AccountEditProps } from "./EditEmail";
import { updateProfile } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { SKInput } from "../../components/SKInput";

const EditName = ({ close }: AccountEditProps) => {
  const [name, setName] = useState("");
  const [isValidForm, setIsValidForm] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
  const [updated, setUpdated] = useState(false);

  const schema = Yup.object().shape({
    name: Yup.string().max(150).required("Name required"),
  });

  useEffect(() => {
    const validate = async (name: string) => {
      try {
        await schema.validate({ name }, { abortEarly: true });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    name && validate(name);
  }, [name]);

  const onInputEvent = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (event.type === "focus") {
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return;
    }
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  const updateUserName = async () => {
    if (!auth || !auth.currentUser) return;
    try {
      await updateProfile(auth.currentUser, { displayName: name });
      console.log("Display name updated successfully");
      close();
    } catch (error) {
      console.error("Error updating display name:", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      {updated ? (
        <div className="p-6 bg-white rounded-lg shadow-lg w-80">
          <h2 className="mb-4 text-lg font-semibold">Edit Name</h2>
          <div className="mb-5 flex flex-col space-y-[10px] w-full">
            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Name successfully Updated.
            </label>
          </div>
          <div className="flex flex-col space-y-2">
            <button
              className="px-4 py-2 text-black border border-black rounded-md"
              onClick={() => {
                close();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="p-6 bg-white rounded-lg shadow-lg w-80">
          <h2 className="mb-4 text-lg font-semibold">Edit Name</h2>
          <div className="mb-5 flex flex-col space-y-[10px] w-full">
            <SKInput
              name="name"
              type="text"
              heading="Name"
              maxLength={150}
              error={errors.name}
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>
          <div className="flex flex-col space-y-2">
            <button
              className="px-4 py-2 text-black bg-white border border-black rounded-md"
              onClick={e => {
                updateUserName();
                //onAction(contentId, action, moderationData.reason, moderationData.note);
              }}
              disabled={!isValidForm}
            >
              Update
            </button>
            <button
              className="px-4 py-2 text-red-600 border border-black rounded-md"
              onClick={() => {
                close();
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditName;
